import {
    Align,
    Box,
    BoxContent,
    DirectionEnum,
    FlexBox,
    FlexItem,
    GapSize,
    Icon,
    IconName,
    Image,
    Justify,
    Price,
    Text,
    TextLevels,
    TrilogyColor,
    TypographyBold,
} from '@bytel/trilogy-react';

import { JOURNEYS, PlanType } from '@app-types/product';

import { paths } from '@helpers/path';

interface ChangePlanCategoryProps {
    journey: JOURNEYS;
    plan: PlanType;
}

export function ChangePlanCategory({ journey, plan }: Readonly<ChangePlanCategoryProps>) {
    if (journey === JOURNEYS.PACKS) {
        return <SwitchToClassic plan={plan} />;
    }

    return <SwitchToPacks plan={plan} />;
}

function SwitchToClassic({ plan }: Readonly<Pick<ChangePlanCategoryProps, 'plan'>>) {
    return (
        <Box href={paths.plans} backgroundColor={TrilogyColor.MAIN_FADE} flat shadowless className='is-marginless'>
            <BoxContent>
                <FlexBox direction={DirectionEnum.ROW}>
                    <FlexItem>
                        <FlexBox direction={DirectionEnum.COLUMN} gap={GapSize.FOUR}>
                            <Text level={TextLevels.ONE} typo={TypographyBold.TEXT_WEIGHT_SEMIBOLD} marginless>
                                Découvrez tous nos forfaits sans engagement
                            </Text>
                            <Price overline='À partir de' amount={plan.prices.final} level={6} period='mois' />
                        </FlexBox>
                    </FlexItem>
                    <FlexItem narrow>
                        <FlexBox align={Align.CENTER} className='is-fullheight'>
                            <Icon name={IconName.ARROW_RIGHT} />
                        </FlexBox>
                    </FlexItem>
                </FlexBox>
            </BoxContent>
        </Box>
    );
}

function SwitchToPacks({ plan }: Readonly<Pick<ChangePlanCategoryProps, 'plan'>>) {
    return (
        <Box href={paths.packs} backgroundColor={TrilogyColor.MAIN_FADE} shadowless>
            <BoxContent>
                <FlexBox direction={DirectionEnum.ROW}>
                    <FlexItem narrow>
                        <FlexBox
                            direction={DirectionEnum.COLUMN}
                            justify={Justify.CENTER}
                            align={Align.CENTER}
                            gap={GapSize.FOUR}
                            className='is-fullheight'
                        >
                            <Image
                                alt='BeIN Sports'
                                src='https://www.bouyguestelecom.fr/assets/media/original/CMS/ECOMMERCE/byou/bein-sports-blue.svg'
                            />
                            <Image
                                alt='Prime'
                                src='https://www.bouyguestelecom.fr/assets/media/original/CMS/ECOMMERCE/byou/amazon-prime-blue.svg'
                            />
                            <Image
                                alt='Deezer'
                                src='https://www.bouyguestelecom.fr/assets/media/original/CMS/ECOMMERCE/byou/deezer-blue.svg'
                            />
                        </FlexBox>
                    </FlexItem>
                    <div
                        style={{
                            borderRight: '1px solid #25465F',
                        }}
                    />
                    <FlexItem>
                        <FlexBox direction={DirectionEnum.COLUMN} gap={GapSize.FOUR}>
                            <Text level={TextLevels.ONE} typo={TypographyBold.TEXT_WEIGHT_SEMIBOLD} marginless>
                                Votre forfait
                                <br />
                                {plan?.dataEnvelope ?? 'B&You'}&nbsp;+ Streaming
                            </Text>
                            <Price overline='à partir de' amount={plan.prices.final} level={6} period='mois' />
                        </FlexBox>
                    </FlexItem>
                    <FlexItem narrow>
                        <FlexBox align={Align.CENTER} className='is-fullheight'>
                            <Icon name={IconName.ARROW_RIGHT} />
                        </FlexBox>
                    </FlexItem>
                </FlexBox>
            </BoxContent>
        </Box>
    );
}
